import { render, staticRenderFns } from "./table-element-item.vue?vue&type=template&id=7a3298b3"
import script from "./table-element-item.vue?vue&type=script&lang=js"
export * from "./table-element-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports